import { render, staticRenderFns } from "./ActivityDemoLinksTabs.vue?vue&type=template&id=38fa9510&"
import script from "./ActivityDemoLinksTabs.vue?vue&type=script&lang=js&"
export * from "./ActivityDemoLinksTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports